import { render, staticRenderFns } from "./BankSlips.vue?vue&type=template&id=7ec85a26&"
import script from "./BankSlips.vue?vue&type=script&lang=js&"
export * from "./BankSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports